import React from 'react'
import { config } from 'config'
import Helmet from 'react-helmet'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'

import PageNav from './PageNav'
import Image from './Image'

import '../css/single.css'

const Component = React.createClass({
  render: function() {
    return (
      <Link to={prefixLink(this.props.link)} style={{
        background: this.props.color,
        marginLeft: this.props.isEnd ? 'auto': '',
        display: 'flex',
        flexShrink: '0',
        height: '100%'
      }}>
        <Image maxWidth={400} width={.6} style={{
          objectFit: 'cover',
          marginBottom: '0',
          mixBlendMode: 'screen',
          WebkitFilter: 'grayscale(77%) contrast(200%)',
          filter: 'grayscale(77%) contrast(200%)'}} imgId={this.props.imgId} alt={this.props.alt} aspectRatio={1}/>
      </Link>
    )
  }
})

export default Component



// WEBPACK FOOTER //
// ../components/ColorSquare.js